enum AppChannel {
  ecomm = 'ecomm', //leaving this open for future enhancements
  virtualCard = 'virtualCard',
  brickAndMortar = 'brickAndMortar',
}

export { AppChannel };
